import React from "react";

import { useScope } from "~/tools/impulse";

import { useTimestampCursorState } from "../../TimestampCursor";
import { useTimelineContext } from "../_context";

import { TimelineMarker } from "./TimelineMarker";

export const TimelineGlobalCursor: React.FC = () => {
	const scope = useScope();
	const { timestampCursor } = useTimelineContext();
	const timestamp = timestampCursor.getValue(scope);
	const timestampCursorState = useTimestampCursorState();

	if (timestamp == null) {
		return null;
	}

	return (
		<TimelineMarker
			dashed
			theme={timestampCursorState.isHotkeyPressed(scope) ? "purple" : "default"}
			timestamp={timestamp}
		/>
	);
};
